import React from 'react';
import CoreApplication, { TargetApplication } from '@esend/core';
import awsconfig from './aws-exports';

function App() {
  return (
    <CoreApplication target={TargetApplication.CUSTOMER} amplifyConfiguration={awsconfig} />
  );
}

export default App;
